/** Persisted while the tab is open so /login?browser_e2e_token survives 401 and ProtectedRoute redirects. */
export const BROWSER_E2E_TOKEN_STORAGE_KEY = 'rodbt_browser_e2e_token';

export function persistBrowserE2eToken(token: string): void {
  const t = token.trim();
  if (t) {
    try {
      sessionStorage.setItem(BROWSER_E2E_TOKEN_STORAGE_KEY, t);
    } catch {
      // ignore quota / private mode
    }
  }
}

export function getPersistedBrowserE2eToken(): string {
  try {
    return sessionStorage.getItem(BROWSER_E2E_TOKEN_STORAGE_KEY)?.trim() || '';
  } catch {
    return '';
  }
}

/** Path for /login, preserving e2e token from current URL or sessionStorage. */
export function getLoginRedirectPath(currentSearch: string): string {
  const urlToken = new URLSearchParams(
    currentSearch.startsWith('?') ? currentSearch.slice(1) : currentSearch,
  )
    .get('browser_e2e_token')
    ?.trim();
  if (urlToken) {
    return `/login?browser_e2e_token=${encodeURIComponent(urlToken)}`;
  }
  const stored = getPersistedBrowserE2eToken();
  if (stored) {
    return `/login?browser_e2e_token=${encodeURIComponent(stored)}`;
  }
  return '/login';
}
